










// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import Edit from '@/components/flux/edit/EditCodic.vue'
import CheckState from '@/components/shared/CheckState.vue'
import { AloFlux, getDefaultAloFlux } from '@/models/alo/AloFlux'
import { TypeOffre } from '@/enum/TypeOffre'

@Component({
  name: 'ReadCodic',    
  components:{CheckState,Edit},  
  props: {
    loading:{
      type:Boolean,
      default:false
    },
    flux:{
      type:Object,
      default:getDefaultAloFlux()
    },
    editable:{
      type:Boolean,
      default:true
    },
  }
})
export default class ReadCodic extends Vue {
  
  private flux!:AloFlux
  private loading!:boolean

  edit() { 
    (this.$refs.edit as Edit).edit(this.flux)
  }

}
